// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1C58y","detailsBorder":"styles_detailsBorder__2iRuX"};